export const getBonuses = (state) => {
  return state.bonuses;
};

export const getDistrictId = (state) => {
  const { districtId } = getBonuses(state);
  return districtId;
};

export const getUserId = (state) => {
  const { userId } = getBonuses(state);
  return userId;
};

export const getTicketId = (state) => {
  const { ticketId } = getBonuses(state);
  return ticketId;
};

export const getBonusMonth = (state) => {
  const { bonusMonth } = getBonuses(state);
  return bonusMonth;
};

export const getShowProcessed = (state) => {
  const { showProcessed } = getBonuses(state);
  return showProcessed;
};
